
class SiteSearch {
    constructor(root){
        this.root = root;
        this.searchField = root.querySelector('.search-field');
        this.searchInput = root.querySelector('input[type="search"]');
        this.container = this.root.querySelector('.site-search__results');
        this.resultsContainer = this.container.querySelector('.site-search__results-inner');
        this.searchResultTemplate = document.querySelector('#search-result--template');

        this.messageTemplate = document.querySelector('#oe-message-template');

        this.timeout = 0;
        this.previousSearchString = '';
        this.jsonURL = '';

        this.pageResults = document.querySelector('.searchresults--js');
        if(typeof(this.pageResults) != 'undefined' && this.pageResults != null && this.pageResults != "") this.filterRow = this.pageResults.querySelector('.filter-row');

        this.topResults = [];

        this.searchInput.addEventListener(
            'keyup',
            this.onInputKeyup.bind(this)
        );

        window.addEventListener(
            'load',
            this.init.bind(this),
            true
        );
    }

    /**
     * Checks if the passed string is different when compared with the previously stored search string this.previousSearchString
     * @param  {String}  value  The search query string that we want to check that has changed
     */
    hasChanged(value){
        if(value == this.previousSearchString){
            return false;
        }

        return true;
    }

    /**
     * Does some light string escaping
     * @param  {String}  string  The string that is to be escaped
     */
    escape(string) {
        return string
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }
    
    isSet(node){
        if (typeof(node) != 'undefined' && node != null && node != "") {
            return true;
        }else{
            return false;
        }
    }

    /**
     * Initialise things here
     */
    init(){
        this.jsonURL = this.root.getAttribute('data-fetch-url');

        if(this.isSet(this.pageResults) && this.isSet(this.filterRow)){
            this.pageFilterTriggers = this.filterRow.querySelectorAll('button[data-type]');

            this.onFilterTriggerClickBound = this.onFilterTriggerClick.bind(this);

            for (let i = 0; i < this.pageFilterTriggers.length; i++) {
                this.pageFilterTriggers[i].addEventListener( 'click', this.onFilterTriggerClickBound, true);
            }
        }
    }

    /**
     * Fetches the results from JSON query
     */
    async fetchJSON(){
        const cleanValue = this.escape(this.searchInput.value);
        const searchURL = this.jsonURL + cleanValue;

        let responseJSON;

        try {
            const response = await fetch(searchURL);

            if (!response.ok) {
                // Handle response error
                throw new Error(`${response.status} ${response.statusText}`);
            }

            responseJSON = await response.json();
            
        } catch (error) {
            if (error instanceof SyntaxError) {
                console.warn('There was a SyntaxError when fetching the JSON', error);
            } else {
                console.warn('There was an error', error);
            }
        }

        if (responseJSON) {
            this.getTotalCounts(responseJSON);
            this.organiseJSON(responseJSON);
        }
    }

    /**
     * Counts the total items
     * @param {*} json JSON list of search results
     */
    getTotalCounts(json){
        this.totalCount = json.total;
    }

    /**
     * Gets and stores only the top JSON results
     * @param {*} json JSON list of search results
     */
    organiseJSON(json){
        const list = json.list;

        this.topResults = [];

        if(this.topResults.length === 5){
            this.buildResults();
            return;
        }

        for (let i = 0; i < list.length; i++) {
            let result = list[i];

            if(this.topResults.length === 5) break;

            this.topResults.push(result);
        }

        this.buildResults();
    }

    /**
     * Handles all keyup keyboard events
     * @param  {Object}  e  The event that triggered this method
     */
    onInputKeyup(e) {
        if(this.searchInput.value.length == 0 || this.searchInput.value == ''){
            this.removeResults();
            this.removeResultsFooter();
            this.clearMessages();
            this.container.append(
                this.buildMessage('Explore our services, case studies, insights and team', 'fa-search')
            );
            return;
        }

        if(!this.hasChanged(this.searchInput.value)){
            return;
        }

        this.previousSearchString = this.searchInput.value;

        if(this.searchInput.value.length <= 3){
            this.clearMessages();
            this.removeResultsFooter();
            this.removeResults();

            this.container.append(
                this.buildMessage('Please Keep Typing...', 'fa-i-cursor')
            )
            return;
        }

        clearTimeout(this.timeout);

        if(!this.isSet(this.container.querySelector('.fa-spinner'))){
            this.clearMessages();
        }

        if(this.resultsContainer.innerHTML != ''){
            this.container.classList.add('is-searching');
        } else{
            if(!this.isSet(this.container.querySelector('.fa-spinner'))){
                this.container.append(
                    this.buildMessage('Searching...', 'fa-spinner')
                );
            }
        }


        this.timeout = setTimeout(
            this.fetchJSON.bind(this),
            700
        );
    }


    /**
     * Begins the process of building the resulting HTML
     */
    buildResults(){
        this.clearMessages();
        this.container.classList.remove('is-searching');

        if(this.topResults.length >= 1){
            this.removeResults();
            this.populateResults();
            this.buildResultsFooter();
        } else{
            this.removeResults();
            this.removeResultsFooter();

            this.container.append(
                this.buildMessage('No results were found, please try a different search', 'fa-undo-alt')
            );
        }
    }


    /**
     * Populates and appends a results
     */
    populateResults(){
        const resultsHeader = document.createElement('p');
        resultsHeader.textContent = 'Best matches:';

        this.resultsContainer.append(resultsHeader);

        for (let i = 0; i < this.topResults.length; i++) {
            let result = this.topResults[i];

            let searchResultElement = this.searchResultTemplate.content.cloneNode(true).children[0];

            if(
                !this.isSet(result.title) ||
                !this.isSet(result.href)
            ){
                return;
            }

            searchResultElement.querySelector('.search-result__title').textContent = result.title;
            searchResultElement.querySelector('.search-result__link').href = result.href;

            if(this.isSet(result.img)){
                searchResultElement.querySelector('.search-result__thumbnail').src = result.img;
            }

            if(this.isSet(result.excerpt)){
                searchResultElement.querySelector('.search-result__excerpt').textContent = result.excerpt;
            }

            if(this.isSet(result.type)){
                searchResultElement.querySelector('.search-result__type').textContent = result.type;
            }

            this.resultsContainer.appendChild(searchResultElement);
        }
    }

    /**
     * Removes the results
     */
    removeResults(){
        this.resultsContainer.innerHTML = '';
    }

    buildMessage(message, icon, classes){
        let messageElement = this.messageTemplate.content.cloneNode(true).children[0];

        if(this.isSet(message)) messageElement.querySelector('.oe-message__body__p').innerHTML = message;
        
        if(this.isSet(icon)) messageElement.querySelector('.oe-message__icon').classList.add(icon);

        if(this.isSet(classes)) messageElement.classList.add(classes);

        return messageElement;
    }

    clearMessages(){
        const messages = this.container.querySelectorAll('.oe-message');

        messages.forEach((message) => {
            message.remove();
        })
    }


    buildResultsFooter(){
        this.removeResultsFooter();

        const fragment = new DocumentFragment();

        const resultsFooter = document.createElement('footer');
        resultsFooter.classList.add('modal-footer', 'site-search__footer');

        const resultsFooterButton = document.createElement('a');
        resultsFooterButton.href = '/search/?q=' + this.escape(this.searchInput.value);
        resultsFooterButton.classList.add('block--button-link', 'is-oe-pink', 'has-background', 'is-size-large');

        const resultsFooterButtonSpan = document.createElement('span');
        resultsFooterButtonSpan.textContent = 'View All Results (' + this.totalCount + ')';

        resultsFooterButton.append(resultsFooterButtonSpan);

        resultsFooter.append(resultsFooterButton);
        fragment.append(resultsFooter);

        this.root.append(fragment);
    }

    removeResultsFooter(){
        const resultsFooter = this.root.querySelector('.site-search__footer');

        if(this.isSet(resultsFooter)) resultsFooter.remove();
    }

    onFilterTriggerClick(e){
        const type = e.target.dataset.type;
        
        this.pageSearchResults = Array.from(this.pageResults.querySelectorAll('.block--article-card--insight'));

        if(!this.isSet(type) || type === ''){
            this.pageSearchResults.forEach((result) => result.classList.remove('is-hidden'));
            return;
        }

        let hiddenResults = this.pageSearchResults.filter((result) => !result.classList.contains(type));

        if(type === 'case-studies'){
            hiddenResults = hiddenResults.filter((result) => !result.classList.contains('testimonial'));
        }

        this.pageSearchResults.forEach((result) => result.classList.remove('is-hidden'));
        hiddenResults.forEach((result) => result.classList.add('is-hidden'));
    }
}

const siteSearch = document.querySelector('.site-search--js');
if(siteSearch){
    new SiteSearch(siteSearch);
}
